<template>
	<el-tag v-if="status == orderStatus.PartsOrdering" :size="tagSize" type="warning" class="filled" effect="plain">Заказ запчастей</el-tag>
	<el-tag v-if="status == orderStatus.PartsAwaiting" :size="tagSize" type="warning" class="filled" effect="plain">Ожидание запчастей</el-tag>
	<el-tag v-if="status == orderStatus.VisitNegotiating" :size="tagSize" type="warning" class="filled" effect="plain">Согласование визита</el-tag>
	<el-tag v-if="status == orderStatus.VisitAwaiting" :size="tagSize" type="primary" class="filled" effect="plain">Ожидание визита</el-tag>
	<el-tag v-if="status == orderStatus.VehicleAccepted" :size="tagSize" type="primary" class="filled" effect="plain">Автомобиль принят</el-tag>
	<el-tag v-if="status == orderStatus.VehicleInProgress" :size="tagSize" type="primary" class="filled" effect="plain">Выполнение работ</el-tag>
	<el-tag v-if="status == orderStatus.ExtraNegotiating" :size="tagSize" type="warning" class="filled" effect="plain">Доп. согласование</el-tag>
	<el-tag v-if="status == orderStatus.VehicleCompleted" :size="tagSize" type="success" class="filled" effect="plain">Работы выполнены</el-tag>
    <el-tag v-if="status == orderStatus.Closed" :size="tagSize" effect="plain" type="info" class="filled">Закрыт</el-tag>	
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElTag } from 'element-plus';
import OrderStatus from '@/models/enums/OrderStatus';

@Options({	
	components: {
		ElTag
	},
	props: {
		status: Number,
		size: String
	}
})
export default class OrderStatusComponent extends Vue {
	/** props */
	status!: Number;
	size!: String;

	/** constants */
	orderStatus = OrderStatus;

	/** view-models */
	tagSize: String = 'small';

	mounted(): void {
		if (this.size) {
			this.tagSize = this.size;
		}
	}

	// PartsOrdering = 1,
	// /** Ожидание запчастей */
	// PartsAwaiting = 2,	
	// /** Согласование визита */
	// VisitNegotiating = 3,
	// /** Ожидание визита */
	// VisitAwaiting = 4,	
	// /** Автомобиль принят */
	// VehicleAccepted = 5,
	// /** Выполнение работ */
	// VehicleInProgress = 6,	
	// /** Доп. согласование  */
	// ExtraNegotiating = 7,	
	// /** Работы выполнены */
	// VehicleCompleted = 8,
	// /** Закрыт	*/
	// Closed = 9		
}
</script>